export const faqs = [
  ['Is this a physical product?', 'No. This is a 100% digital product delivered electronically.'],
  [
    'Who is this bundle for?',
    'Qualified physical therapists, physiotherapists, geriatric rehabilitation specialists, and rehabilitation professionals.',
  ],
  [
    'Do I need professional training?',
    'Yes. This is a professional reference resource and does not replace clinical education or licensing requirements.',
  ],
  [
    'Are the exercises explained step by step?',
    'Yes. The material includes practical execution instructions, dosage, assistance guidance, and modifications.',
  ],
  [
    'Are complete rehabilitation sessions included?',
    "Yes. You'll find 20-, 30-, and 40-minute treatment examples and structured multiweek programs.",
  ],
  ['Are all five bonuses included?', 'Yes. All five practical bonuses are included at no additional cost.'],
  [
    'How do I receive the product?',
    "You'll receive digital access according to the instructions provided after purchase.",
  ],
  ['Is this a subscription?', 'No. It is a one-time purchase of $26.90 USD.'],
  [
    'Does this replace clinical assessment or professional judgment?',
    "No. Every intervention must be selected and adapted by a qualified professional based on the patient's needs and safety requirements.",
  ],
  ['Is there a guarantee?', "Yes. The offer includes a 7-day guarantee, subject to the store's refund policy."],
] as const
